import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LegalEntityInstructionFacade } from "./facades/legal-entity-instructions.facade";

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    LegalEntityInstructionFacade
  ]
})
export class LegalEntityInstructionModule {}
